<template>
  <CustomButton
    :text="category.name"
    :url="categoryLink"
    type="highlight"
    class="flex-none scroll-snap-start snap-start w-fit"
  />
</template>

<script lang="ts">

import type { SiblingCategory } from '~~/types/product/ProductCategories';
import { buildCategoryPageUrl } from '~~/helpers/category/buildCategoryPageUrl';

export default defineComponent({
  name: 'PdpSiblingCategory',

  props: {
    category: {
      type: Object as PropType<SiblingCategory>,
      required: true,
    },
  },
  setup(props) {

    const { countryCode } = useLocalization();
    const { category } = toRefs(props) as { category: Ref<SiblingCategory> };
    const categorySlug = computed(() => category.value.slug);
    const categoryLink = computed(() => buildCategoryPageUrl({
      category: categorySlug.value,
      countryCode: countryCode.value,
    }));

    return { categoryLink };
  
  },
});

</script>
